import { FC, Fragment } from "react";

export type LinkLoginprops = {
  texto: string;
  onClick: () => void;
};

export const LinkLogin: FC<LinkLoginprops> = ({ texto, onClick }) => {
  return (
    <Fragment>
      <button
        type="button"
        onClick={(e) => {
          e.preventDefault();
          onClick();
        }}
        className="font-semibold text-customPurple/90 hover:text-customPurple/70"
      >
        {texto}
      </button>
    </Fragment>
  );
};
